/**
 * @generated SignedSource<<5e518c394dd8e1e14eb75eacaffdb313>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useLibraryModelCreateMutation$variables = {
  description?: string | null;
  displayName: string;
  targetTableDefinitionNames?: ReadonlyArray<string> | null;
  targetTableDefinitionsPackageName: string;
};
export type useLibraryModelCreateMutation$data = {
  readonly createTargetTableDefinitionsPackage: {
    readonly name: string;
    readonly owner: {
      readonly name: string;
    };
    readonly targetTableDefinitions: ReadonlyArray<{
      readonly name: string;
    }> | null;
    readonly uid: string;
  };
};
export type useLibraryModelCreateMutation = {
  response: useLibraryModelCreateMutation$data;
  variables: useLibraryModelCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "displayName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetTableDefinitionNames"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetTableDefinitionsPackageName"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "displayName",
        "variableName": "displayName"
      },
      {
        "kind": "Variable",
        "name": "targetTableDefinitionNames",
        "variableName": "targetTableDefinitionNames"
      },
      {
        "kind": "Variable",
        "name": "targetTableDefinitionsPackageName",
        "variableName": "targetTableDefinitionsPackageName"
      }
    ],
    "concreteType": "TargetTableDefinitionsPackage",
    "kind": "LinkedField",
    "name": "createTargetTableDefinitionsPackage",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetTableDefinition",
        "kind": "LinkedField",
        "name": "targetTableDefinitions",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Owner",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useLibraryModelCreateMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useLibraryModelCreateMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "bdddd212cfdc5ffb26906ca221bcf5fa",
    "id": null,
    "metadata": {},
    "name": "useLibraryModelCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useLibraryModelCreateMutation(\n  $targetTableDefinitionsPackageName: String!\n  $targetTableDefinitionNames: [String!]\n  $description: String\n  $displayName: String!\n) {\n  createTargetTableDefinitionsPackage(targetTableDefinitionsPackageName: $targetTableDefinitionsPackageName, targetTableDefinitionNames: $targetTableDefinitionNames, description: $description, displayName: $displayName) {\n    name\n    uid\n    targetTableDefinitions {\n      name\n    }\n    owner {\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76a6a28ac8dccd2d52e7973d025dfc60";

export default node;
